import React, { useEffect, useRef } from "react";

export default function Paypal(props) {
  const product = {
    price: Number(props.price),
  };

  let paypal = useRef();

  useEffect(() => {
    window.paypal
      .Buttons({
        createOrder: (data, actions, error) => {
          return actions.order.create({
            intent: "CAPTURE",
            purchase_units: [
              {
                description: "Example Subscription",
                amount: {
                  curreny_code: "USD",
                  value: props.price,
                  //   value: 20,
                },
              },
            ],
            // payer: {
            //   email_address: "vaibhavsinha619@gmail.com",
            //   //   phone: {
            //   //     phone_number: "6205630243",
            //   //   },
            // },
          });
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture();
        },
        onError: (err) => {},
      })
      .render(paypal.current);
  }, []);

  return (
    <div>
      <div ref={paypal}></div>
    </div>
  );
}
